import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {Section, useTheme} from '@primer/react-brand/esm'
import {Product} from '../../../../../brand/components/Product'
import type {ModelsSectionContent} from '../../content'
import {Cards} from '../../_components/Cards/Cards'
import {ResponsiveImage} from '../../_components/ResponsiveImage/ResponsiveImage'
import {pickResponsiveImages} from '../../_components/ResponsiveImage/pick-responsive-images'

import styles from './ModelsSection.module.css'

type Props = {
  contentfulContent: ModelsSectionContent
}

export function ModelsSection({contentfulContent}: Props) {
  const {colorMode} = useTheme()
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro

  const visualImages = pickResponsiveImages(contentfulContent.visual?.fields.media)

  const cards = contentfulContent.cards

  return (
    <Section id={sectionId} fullWidth paddingBlockEnd="none">
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} /> : null}

      {visualImages ? (
        <Section
          as="div"
          variant="gridline"
          paddingBlockStart="none"
          paddingBlockEnd="none"
          data-padding-inline="0"
          data-center-on-tablet
        >
          <Product minPadding="0" theme={colorMode} className={styles.Background}>
            <ResponsiveImage images={visualImages} className={styles.Visual} />
          </Product>
        </Section>
      ) : null}

      {cards ? <Cards component={cards} /> : null}
    </Section>
  )
}
